import { lazy } from 'react';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import PrivateRoute from './PrivateRoute';
import { Routes, Route } from 'react-router-dom';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing



import React from 'react';



// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

const AddEssay = Loadable(lazy(() => import("../views/Admin/Essay/AddEssay")))
const AddQuiz = Loadable(lazy(() => import("../views/Admin/Quiz/AddQuiz")))

const EssayList = Loadable(lazy(() => import("../views/Admin/Essay/EssayList")))
const QuizList = Loadable(lazy(() => import("../views/Admin/Quiz/QuizList")))


const CheckQuiz = Loadable(lazy(() => import("../views/Admin/Quiz/CheckQuiz")))
const CheckEssay = Loadable(lazy(() => import("../views/Admin/Essay/CheckEssay")))

const CheckIndividualEssay = Loadable(lazy(() => import("../views/Admin/Essay/CheckIndiviual")))
const CheckIndiviualQuiz = Loadable(lazy(() => import("../views/Admin/Quiz/CheckIndiviualQuiz")))

const EssayWinner = Loadable(lazy(() => import("../views/Winners/EssayWinners")));
const QuizWinner = Loadable(lazy(() => import("../views/Winners/QuizWinners")));
const QuizDetail = Loadable(lazy(() => import("../views/Winners/QuizDetail")))


//Auth

const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const Forgot = Loadable(lazy(() => import("../views/pages/authentication/authentication3/ForgotPassword")))
const UnAuthorizec = Loadable(lazy(() => import("../views/pages/authentication/UnAuthorized")))

const NotFound = Loadable(lazy(() => import("../views/pages/authentication/NotFound")))

//Exam

const EssayExam = Loadable(lazy(() => import("../views/Students/Essay")))
const QuizExam = Loadable(lazy(() => import("../views/Students/Quiz")));
const EssayExamContinue = Loadable(lazy(()=>import('../views/Students/EssayContinue.js')));
const QuizExamContinue = Loadable(lazy(()=>import('../views/Students/QuizContinue')));

const TermsandConditions = Loadable(lazy(() => import("../views/PrivacyViews/Termsandconditions")))
const Introduction = Loadable(lazy(() => import("../views/Logic/Introduction")))
const FAQ = Loadable(lazy(() => import("../views/Logic/FAQs")))
const ViewQuestion = Loadable(lazy(() => import('../views/Admin/Quiz/ViewQuestion')))

const EssayWinnerDetail = Loadable(lazy(() => import('../views/Winners/EssayDetailWinner')))
const AssiginEssay = Loadable(lazy(() => import('../views/Admin/Essay/AsiginEssay')))

const TeacherEssayList = Loadable(lazy(() => import('../views/Teacher/EssayList')));
const TeacherCheckEssay = Loadable(lazy(() => import('../views/Teacher/TeacherCheckEssay')));
const TeacherInviualCheckQuiz = Loadable(lazy(() => import('../views/Teacher/TeacherInviualCheckQuiz')));

const CheckEssayByTeacher = Loadable(lazy(() => import('../views/Admin/Essay/CheckEssayByTeacher')));
const CheckTeachersEssay = Loadable(lazy(() => import('../views/Admin/Essay/EssayByTeacher')));

const StudentProfile = Loadable(lazy(() => import('../views/utilities/StudentProfile')));
const EssayDetail = Loadable(lazy(() => import('../views/utilities/EssayDetail')));
const QuizDetailss = Loadable(lazy(() => import('../views/utilities/QuizDetail')));


//Annoucemetns
const Annoucemetns = Loadable(lazy(() => import('../views/Admin/Annoucements/Annoucements')));
const AnnoucmentsAll =  Loadable(lazy(() => import('../views/utilities/AnnoucmentsAll')));




export default function RouteNew() {
    return (
        <>
            <Routes>

                <Route>



                    {/* Global Vrification Routes */}
                    <Route path="/MyHussain" element={<MinimalLayout />}>
                        <Route path="/MyHussain/login" element={<AuthLogin3 />} />
                        <Route path="/MyHussain/ForgotPassword" element={<Forgot />} />
                        <Route path="/MyHussain/Register" element={<AuthRegister3 />} />
                        <Route path="/MyHussain/TermsandConditions" element={<TermsandConditions />} />
                    </Route>


                    {/* Dashboard Route For Student and Admin */}
                    <Route element={<PrivateRoute allowedRoles={['Student', 'Admin', 'Teacher']} />} >
                        <Route path="/" element={<MainLayout />}>
                            <Route path="/" element={<DashboardDefault />} />
                            <Route path="/dashboard/default" element={<DashboardDefault />} />
                            <Route path="/dashboard/introduction" element={<Introduction />} />
                            <Route path="/dashboard/FAQ" element={<FAQ />} />
                        </Route>
                    </Route>


                    {/* Admin Routes  */}
                    <Route element={<PrivateRoute allowedRoles={['Admin']} />}>
                        <Route path="/Operations" element={<MainLayout />}>
                            <Route path="/Operations/AddEssay" element={<AddEssay />} />
                            <Route path="/Operations/AddQuiz" element={<AddQuiz />} />
                            <Route path="/Operations/Announcement" element={<Annoucemetns />} />
                            <Route path="/Operations/CheckQuiz" element={<CheckQuiz />} />
                            <Route path="/Operations/CheckEssay" element={<CheckEssay />} />
                            <Route path="/Operations/CheckIndividualEssay" element={<CheckIndividualEssay />} />
                            <Route path="/Operations/CheckIndiviualQuiz" element={<CheckIndiviualQuiz />} />
                            <Route path="/Operations/ViewQuestion" element={<ViewQuestion />} />
                            <Route path="/Operations/CheckQuiz/AssiginEssay" element={<AssiginEssay />} />
                            <Route path="/Operations/CheckEssayByTeacher" element={<CheckEssayByTeacher />} />
                            <Route path="/Operations/CheckTeachersEssay" element={<CheckTeachersEssay />} />
                            <Route path="/Operations/StudentProfile" element={<StudentProfile />} />
                            <Route path="/Operations/StudentProfile/ViewDetailEssay" element={<EssayDetail />} />
                            <Route path="/Operations/StudentProfile/QuizDetail" element={<QuizDetailss />} />
                            <Route path="/Operations/StudentProfile/QuizDetail" element={<QuizDetailss />} />
                        </Route>
                    </Route>

                    {/* Routes For Both Admin and Students */}
                    <Route element={<PrivateRoute allowedRoles={['Student', 'Admin']} />}>
                        <Route path="/MyHussain" element={<MainLayout />}>
                            <Route path="/MyHussain/EssayList" element={<EssayList />} />
                            <Route path="/MyHussain/QuizList" element={<QuizList />} />
                        </Route>
                    </Route>

                    <Route element={<PrivateRoute allowedRoles={['Student', 'Admin', 'Teacher']} />}>
                        <Route path="/MyHussain" element={<MainLayout />}>
                            <Route path="/MyHussain/EssayWinner" element={<EssayWinner />} />
                            <Route path="/MyHussain/QuizWinner" element={<QuizWinner />} />
                            <Route path="/MyHussain/EssayWinnerDetail" element={<EssayWinnerDetail />} />
                            <Route path="/MyHussain/QuizDetail" element={<QuizDetail />} />
                            <Route path="/MyHussain/AnnoucmentsAll" element={<AnnoucmentsAll />} />
                        </Route>
                    </Route>


                    <Route element={<PrivateRoute allowedRoles={['Teacher']} />}>
                        <Route path="/MyHussain" element={<MainLayout />}>
                            <Route path="/MyHussain/TeacherEssayList" element={<TeacherEssayList />} />
                            <Route path="/MyHussain/TeacherCheckEssay" element={<TeacherCheckEssay />} />
                            <Route path="/MyHussain/TeacherInviualCheckQuiz" element={<TeacherInviualCheckQuiz />} />
                        </Route>
                    </Route>




                    <Route element={<PrivateRoute allowedRoles={['Student']} />}>
                        <Route path="/ExamStart" element={<MainLayout />}>
                            <Route path="/ExamStart/EssayExam" element={<EssayExam />} />
                            <Route path="/ExamStart/QuizExam" element={<QuizExam />} />
                            <Route path="/ExamStart/ContinueEssayExam" element={<EssayExamContinue />} />
                            <Route path="/ExamStart/ContinueQuizExam" element={<QuizExamContinue />} />
                        </Route>
                    </Route>

                    <Route path="*" element={<NotFound />} />
                    <Route path="/MyHussain/Unauthorized404" element={<UnAuthorizec />} />

                </Route>
            </Routes>

        </>
    );
}





